import { render, staticRenderFns } from "./AssignmentToTalkgroup.vue?vue&type=template&id=1e4b9824&scoped=true"
import script from "./AssignmentToTalkgroup.vue?vue&type=script&lang=js"
export * from "./AssignmentToTalkgroup.vue?vue&type=script&lang=js"
import style0 from "./AssignmentToTalkgroup.vue?vue&type=style&index=0&id=1e4b9824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b9824",
  null
  
)

export default component.exports